import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "800",
  height: "800",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--ci-primary-color, #000000)",
      class: "ci-primary",
      d: "m43.314 130.51 51.882-51.883v417.569h32V78.627l51.883 51.883 22.627-22.627-90.51-90.511-90.51 90.511 22.628 22.627z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--ci-primary-color, #000000)",
      class: "ci-primary",
      d: "M184 160h120v32H184zM184 232h184v32H184zM184 304h248v32H184zM184 376h312v32H184z"
    }, null, -1)
  ]))]))
}
export default { render };